import React from 'react';
import { Image, ImageSourcePropType, StyleSheet } from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import { TimageINT } from '../../store/slices/gameObjectSlice';



interface InstaAvatarProps {
    profilePic: ImageSourcePropType,
    size: number;
}

export const InstaAvatar: React.FC<InstaAvatarProps> = ({ profilePic, size }) => {
    size = moderateScale(size, 0.2);

    const styles = StyleSheet.create({
        profilePic: {

            // aspectRatio: 1,
            borderRadius: size / 2,
            height: size,
            width: size,
            // borderColor: "#a098a9",
            // borderWidth: 1.2,
            overflow: "hidden",
            // width: "100%",
            // height: "100%",



        },
    });
    return (
        <Image resizeMode={"cover"} source={profilePic} style={[styles.profilePic]} />
    );
};